module.exports = __webpack_public_path__ + "static/img/1d19c5d8.c10.709a015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/1d19c5d8.c10.jpg
// module id = 1JPC
// module chunks = 2